module.exports = __webpack_public_path__ + "static/media/19ESCAP8.e2e28f57.jpg";